var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClipboardPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350.906,
    height: 128.788,
    viewBox: "0 0 350.906 128.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-clipboard-pencil"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4703",
    "data-name": "Rectangle 4703",
    width: 142.675,
    height: 121.111,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24412",
    "data-name": "Group 24412",
    transform: "translate(-573.199 -223.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24377",
    "data-name": "Group 24377",
    transform: "translate(6646 11233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46358",
    "data-name": "Path 46358",
    d: "M52.3,544.094c28.884,0,52.3,3.437,52.3,7.679s-23.417,7.675-52.3,7.675S0,556.006,0,551.773s23.414-7.679,52.3-7.679",
    transform: "translate(-5937.029 -11440.531)",
    fill: "#e3e7fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24374",
    "data-name": "Group 24374",
    transform: "translate(-5966.467 -11009.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24372",
    "data-name": "Group 24372",
    clipPath: "url(#clip-path-icon-clipboard-pencil)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46295",
    "data-name": "Path 46295",
    d: "M4.649.1,93.132,3.669a3.275,3.275,0,0,1,3.2,3.2l1.381,107.408c.023,1.761-2.825,4.015-4.584,4.071L3.2,121.192a3.178,3.178,0,0,1-3.2-3.2V4.886C0,3.124,2.889.027,4.649.1",
    transform: "translate(0 -0.083)",
    fill: "#343d63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46296",
    "data-name": "Path 46296",
    d: "M15.473,0,105.4,1.987a3.237,3.237,0,0,1,3.2,3.2V113.466a3.25,3.25,0,0,1-3.2,3.2l-89.93,2.842a3.178,3.178,0,0,1-3.2-3.2V3.2a3.188,3.188,0,0,1,3.2-3.2",
    transform: "translate(-10.449 0)",
    fill: "#d1e4f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46297",
    "data-name": "Path 46297",
    d: "M140.3,222.625l-59.066.866a1.046,1.046,0,0,1-1.068-1.049,1.091,1.091,0,0,1,1.068-1.087l59.066-.867a1.047,1.047,0,0,1,1.068,1.051,1.09,1.09,0,0,1-1.068,1.086",
    transform: "translate(-68.269 -187.756)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46298",
    "data-name": "Path 46298",
    d: "M278.031,262.107l-51.868.745a1.048,1.048,0,0,1-1.069-1.05,1.091,1.091,0,0,1,1.069-1.085l51.868-.745a1.048,1.048,0,0,1,1.069,1.05,1.09,1.09,0,0,1-1.069,1.086",
    transform: "translate(-191.677 -221.378)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46299",
    "data-name": "Path 46299",
    d: "M98.052,267.659l-16.814.284a1.047,1.047,0,0,1-1.068-1.051,1.091,1.091,0,0,1,1.068-1.086l16.814-.283a1.045,1.045,0,0,1,1.068,1.05,1.088,1.088,0,0,1-1.068,1.086",
    transform: "translate(-68.269 -226.106)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46300",
    "data-name": "Path 46300",
    d: "M324.878,304.417l-31.205.4a1.047,1.047,0,0,1-1.068-1.051,1.089,1.089,0,0,1,1.068-1.086l31.205-.4a1.047,1.047,0,0,1,1.068,1.05,1.091,1.091,0,0,1-1.068,1.087",
    transform: "translate(-249.167 -257.406)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46301",
    "data-name": "Path 46301",
    d: "M108.394,307.586l-27.156.458a1.047,1.047,0,0,1-1.068-1.051,1.09,1.09,0,0,1,1.068-1.086l27.156-.458a1.046,1.046,0,0,1,1.068,1.05,1.091,1.091,0,0,1-1.068,1.087",
    transform: "translate(-68.269 -260.104)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46302",
    "data-name": "Path 46302",
    d: "M519.417,221l-9.788.165a1.046,1.046,0,0,1-1.069-1.05,1.09,1.09,0,0,1,1.069-1.086l9.788-.166a1.048,1.048,0,0,1,1.069,1.051A1.09,1.09,0,0,1,519.417,221",
    transform: "translate(-433.063 -186.371)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46303",
    "data-name": "Path 46303",
    d: "M154.622,370.675l-9.788.165a1.046,1.046,0,0,1-1.069-1.05,1.09,1.09,0,0,1,1.069-1.086l9.788-.166a1.048,1.048,0,0,1,1.068,1.051,1.09,1.09,0,0,1-1.068,1.086m-46.229,12.854-27.155.459a1.048,1.048,0,0,1-1.068-1.051,1.09,1.09,0,0,1,1.068-1.086l27.155-.458a1.046,1.046,0,0,1,1.068,1.05,1.091,1.091,0,0,1-1.068,1.087m35.585-.47-31.205.4a1.047,1.047,0,0,1-1.068-1.051,1.09,1.09,0,0,1,1.068-1.086l31.205-.4a1.047,1.047,0,0,1,1.068,1.05,1.091,1.091,0,0,1-1.068,1.087M98.053,377.6l-16.814.284a1.047,1.047,0,0,1-1.068-1.05,1.09,1.09,0,0,1,1.068-1.086l16.814-.284a1.046,1.046,0,0,1,1.068,1.05,1.089,1.089,0,0,1-1.068,1.086m56.57-.824-51.869.745a1.047,1.047,0,0,1-1.069-1.05,1.09,1.09,0,0,1,1.069-1.085l51.869-.745a1.047,1.047,0,0,1,1.068,1.05,1.09,1.09,0,0,1-1.068,1.087M140.3,370.917l-59.066.866a1.046,1.046,0,0,1-1.068-1.05,1.09,1.09,0,0,1,1.068-1.086l59.066-.867a1.048,1.048,0,0,1,1.069,1.051,1.09,1.09,0,0,1-1.069,1.086",
    transform: "translate(-68.269 -313.828)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46304",
    "data-name": "Path 46304",
    d: "M154.622,520.351l-9.788.165a1.046,1.046,0,0,1-1.069-1.05,1.09,1.09,0,0,1,1.069-1.086l9.788-.166a1.048,1.048,0,0,1,1.068,1.051,1.09,1.09,0,0,1-1.068,1.086m-46.229,12.854-27.155.458a1.048,1.048,0,0,1-1.068-1.051,1.09,1.09,0,0,1,1.068-1.086l27.155-.458a1.047,1.047,0,0,1,1.068,1.05,1.091,1.091,0,0,1-1.068,1.087m35.585-.47-31.205.4a1.047,1.047,0,0,1-1.068-1.051,1.09,1.09,0,0,1,1.068-1.086l31.205-.4a1.047,1.047,0,0,1,1.068,1.05,1.091,1.091,0,0,1-1.068,1.087m-45.927-5.458-16.814.284a1.047,1.047,0,0,1-1.068-1.05,1.09,1.09,0,0,1,1.068-1.086l16.814-.284a1.046,1.046,0,0,1,1.068,1.05,1.09,1.09,0,0,1-1.068,1.087m56.57-.824-51.869.745a1.048,1.048,0,0,1-1.069-1.05,1.091,1.091,0,0,1,1.069-1.086l51.869-.745a1.047,1.047,0,0,1,1.068,1.05,1.09,1.09,0,0,1-1.068,1.086M140.3,520.593l-59.066.866a1.046,1.046,0,0,1-1.068-1.05,1.09,1.09,0,0,1,1.068-1.087l59.066-.867a1.047,1.047,0,0,1,1.069,1.051,1.09,1.09,0,0,1-1.069,1.086",
    transform: "translate(-68.269 -441.284)",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46305",
    "data-name": "Path 46305",
    d: "M84.236,326.649l63.724-1.122.008.5-63.724,1.122Z",
    transform: "translate(-71.731 -277.202)",
    fill: "#0d37c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46306",
    "data-name": "Path 46306",
    d: "M73.406,538.534a30.047,30.047,0,0,0-3.121-.253q-.388.152-.744.329a7.209,7.209,0,0,0-1.105.669l-.3-.4a7.5,7.5,0,0,1,.961-.6,13.56,13.56,0,0,0-4.117.632,3.662,3.662,0,0,0-2.751,2.909h0a3.857,3.857,0,0,0-.033.434c-.059,3.083,6.912,3.537,10.671,3.608.629.012,1.168.014,1.573.014h.183c3.237.009,6.351-.363,8.27-1.315a4.038,4.038,0,0,0,1.382-1.041,2.131,2.131,0,0,0,.485-1.351,3.836,3.836,0,0,0-.742-2.066c-1.169-1.57-3.712-2.471-6.495-2.719a17.585,17.585,0,0,0-5.921.465c.707.052,1.345.123,1.864.191Zm-3.3-.755.088,0a17.184,17.184,0,0,1,7.373-.892c2.914.259,5.59,1.225,6.851,2.917a3.986,3.986,0,0,1,.379.616,3.918,3.918,0,0,1,.46,1.746,2.615,2.615,0,0,1-.592,1.662,4.526,4.526,0,0,1-1.552,1.177c-1.992.988-5.185,1.375-8.49,1.366h-.183c-.408,0-.953,0-1.58-.014-3.934-.075-11.228-.582-11.161-4.113h0a4.35,4.35,0,0,1,.037-.491,4.124,4.124,0,0,1,3.079-3.315,15.587,15.587,0,0,1,5.292-.66",
    transform: "translate(-52.542 -457.125)",
    fill: "#0d37c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46307",
    "data-name": "Path 46307",
    d: "M652.088,381.867s-1.678-1.372-2.282-1.379-1.749-.308-1.7-.112,1.011.452.845.543-1.568-.287-1.96-.061-1.312,1.161-.573,1.569a10.687,10.687,0,0,0,3.529.981c.572-.076,1.869-.166,1.869-.166Z",
    transform: "translate(-550.215 -323.852)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4701",
    "data-name": "Rectangle 4701",
    width: 73.524,
    height: 6.998,
    transform: "translate(78.34 68.165) rotate(-42.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46308",
    "data-name": "Path 46308",
    d: "M495.361,459.168l-5.64,9.826,10.336-4.639Z",
    transform: "translate(-417.021 -391.004)",
    fill: "#eac6aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46309",
    "data-name": "Path 46309",
    d: "M899.538,105.835l4.276-3.872A2.635,2.635,0,0,0,904,98.251l-1.169-1.292a2.634,2.634,0,0,0-3.711-.184l-4.277,3.872Z",
    transform: "translate(-762 -81.832)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46310",
    "data-name": "Path 46310",
    d: "M493.642,500.031l-3.921,1.76,2.139-3.728c.91-.45,1.721-.521,2.1-.107s.224,1.213-.314,2.074",
    transform: "translate(-417.021 -423.8)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46311",
    "data-name": "Path 46311",
    d: "M760.461,216.254s.9,5.879,1.065,8.183c.082,1.159.2,2.09-.529,2.869,0,0,1.813.177,2.429-.326a1.684,1.684,0,0,1-.232.356,5.892,5.892,0,0,0,2.865-.56c1.271-.859.431-17.96-5.67-16.553,0,0-5.627-.479-5.183,5.042-.094,6.559-.621,12.215-1.061,13.357.633.362,2.162-.829,2.351-1.352.167-.462.259-1,.308-1.138a13.132,13.132,0,0,1-.291,1.681,8.687,8.687,0,0,0,3.247-.991c.969-.733.978-9.429.7-10.569",
    transform: "translate(-642.191 -178.945)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46312",
    "data-name": "Path 46312",
    d: "M811.924,266.411c-.018-.066-.035-.13-.051-.193a4.753,4.753,0,0,0,.152-1.943c.55-.484,1.738-.07,2.745.236.439,4.051.435,8.152.192,8.455-.507.634-1.732.56-1.732.56a2.066,2.066,0,0,0,.14-.356c-.372.5-1.468.326-1.468.326a5.322,5.322,0,0,0,.319-2.869c-.042-.993-.168-2.652-.3-4.217",
    transform: "translate(-691.349 -224.854)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46313",
    "data-name": "Path 46313",
    d: "M687.567,677.247l.672-.114h0l-.671.115Z",
    transform: "translate(-585.496 -576.611)",
    fill: "#636466",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46314",
    "data-name": "Path 46314",
    d: "M757.459,276.7h12.109c-.866-2.17-2.107-3.74-3.049-3.933-.5-.132-1.353-2.2-1.341-5.121l-.228.294-3.8.753s.085,1.2.089,2.324c0,.94-.048,1.9-.262,2.008-.273.024-.523.074-.523.074a9.778,9.778,0,0,0-2.992,3.6",
    transform: "translate(-645.012 -227.918)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46315",
    "data-name": "Path 46315",
    d: "M782.3,270.383s.085,1.2.089,2.324c2.129-.06,3.253-2,3.713-3.077Z",
    transform: "translate(-666.163 -229.603)",
    fill: "#ef8161",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46316",
    "data-name": "Path 46316",
    d: "M772.715,230.107c0-3.137.656-5.238-2.558-5.424s-3.84,1.011-4.1,2.057a13.843,13.843,0,0,0,.295,4.827c1.114,4.055,6.357.579,6.359-1.461",
    transform: "translate(-652.255 -191.312)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46317",
    "data-name": "Path 46317",
    d: "M810.041,734.456l-1.407,5.931-2.109-.013-.077-5.918Z",
    transform: "translate(-686.728 -625.425)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46318",
    "data-name": "Path 46318",
    d: "M679.228,731.684l-4.006,5.677-1.561-2,2.411-4.454Z",
    transform: "translate(-573.655 -622.399)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46319",
    "data-name": "Path 46319",
    d: "M677.945,494.364l2.063.063,2.233.068a44.078,44.078,0,0,0,8.051-14.949q.1-.32.214-.65c1.583-4.616,4.866-10.412,6.6-15.658.275-.835.522-1.622.744-2.366.071-.239.14-.472.206-.7a55.641,55.641,0,0,0,1.984-10.445l-12.491.1a232.828,232.828,0,0,1-9.6,44.538",
    transform: "translate(-577.302 -382.963)",
    fill: "#343d63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46320",
    "data-name": "Path 46320",
    d: "M744.008,309.2c.031,5.943-.872,8.494-.872,8.494a16.784,16.784,0,0,0,11.7.717c.075-.024,5.263-1.208,5.263-1.208-.107-.241-1.052-4.246-1.156-4.467-1.342-2.881-2.361-4.145-2.52-5.031a18.82,18.82,0,0,1-.154-4.979,39.982,39.982,0,0,1,1.541-7.821,40.572,40.572,0,0,1-5.157-1.762,4.026,4.026,0,0,1-2.782,1.032c-1.266-.028-1.676-.57-1.611-1.162-1.35.751-2.426,1.46-2.426,1.46-1.147,1.992-3.473,3.926-3.641,6.982-.042.751,1.809,7.58,1.81,7.746",
    transform: "translate(-632.016 -249.513)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46322",
    "data-name": "Path 46322",
    d: "M806,772.173a5.708,5.708,0,0,0,.269,2.43s.345,1.574-1.2,1.6-1.929-.117-1.754-1.081.509-2.633.509-2.633Z",
    transform: "translate(-684.025 -657.543)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46323",
    "data-name": "Path 46323",
    d: "M802.16,790.85c.984,1.858,2.388,1.724,3.392,0a9.03,9.03,0,0,0-.219-2.472c0-.022-.007-.037-.009-.048a.1.1,0,0,0,0-.015c-1.753,1.606-2.85-.041-2.85-.041a.045.045,0,0,0,0,.009,10.357,10.357,0,0,0-.307,2.568",
    transform: "translate(-683.077 -671.252)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46324",
    "data-name": "Path 46324",
    d: "M648.511,765.685a38.815,38.815,0,0,0,3.733-4.783l2.123,1.088-4.746,4.457-1.111-.145Z",
    transform: "translate(-552.237 -647.945)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46325",
    "data-name": "Path 46325",
    d: "M636.3,773.781H639.9c.529,0,.952-.877,1.522-2.017a1.915,1.915,0,0,1,1.293-.864l-.014,2.881h.83l.763-3.046a2.58,2.58,0,0,0-.316-2.506c-.414,0-1.527.283-3.637,2.659a2.766,2.766,0,0,1-2.219,1.036l-.031.017c-1.753.789-1.782,1.841-1.782,1.841",
    transform: "translate(-541.843 -654.184)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46326",
    "data-name": "Path 46326",
    d: "M691.837,546.336l2.233.068a44.078,44.078,0,0,0,8.051-14.949q.1-.32.214-.65c1.583-4.616,4.866-10.412,6.6-15.658.275-.835.522-1.622.744-2.366.071-.239.14-.472.206-.7l-1.839-1.4s-5.522,8.943-7.232,17.359c-1.485,7.31-7.433,16.106-8.973,18.294",
    transform: "translate(-589.132 -434.872)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46327",
    "data-name": "Path 46327",
    d: "M792.662,515.209c-.032,4.092.175,13.5.708,17.4h1.978c1.093,0,1.638-.015,1.638-.015,1.337-6.773,2.288-12.377,2.981-17.206.568-3.963,1.073-7.361,1.461-10.284.391-2.944.663-5.409.76-7.491.015-.328.027-.648.033-.956s.008-.613.005-.908l-10.793-1.052c.136,7.171,1.245,18.138,1.228,20.516",
    transform: "translate(-673.944 -421.255)",
    fill: "#343d63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46328",
    "data-name": "Path 46328",
    d: "M817.8,549.334c1.093,0,1.638-.015,1.638-.015,1.337-6.773,2.288-12.377,2.981-17.206.568-3.963,1.073-7.361,1.462-10.284.391-2.944.663-5.409.76-7.491l-3.96,2.33s2.527.892,1.563,7.642-3.1,24.069-4.444,25.025",
    transform: "translate(-696.396 -437.983)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46329",
    "data-name": "Path 46329",
    d: "M793.21,326.662s.76,2.747,3.39,2.4a31.734,31.734,0,0,0,6.37-1.928s-1.124-3.552-2.522-8.218c-1.692-5.649-2.113-13.588-3.1-18.181-.277-1.287-2.14-1.705-2.21-2.475l-2.182-4.234s-3.253,7.3-3.429,9.144,3.682,23.5,3.682,23.5",
    transform: "translate(-672.315 -250.375)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46330",
    "data-name": "Path 46330",
    d: "M826.725,361.31c.118,2.982,1.16,8.066,5.35,10.3.016.009.033.017.05.024-1.692-5.649-1.67-11.068-2.657-15.662-2.252-.469-2.807,3.7-2.743,5.337",
    transform: "translate(-703.992 -303.097)",
    fill: "#4b8bcb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46331",
    "data-name": "Path 46331",
    d: "M841.19,435.873s-1.879-.406-2.362.13-.754,1.39-.271,1.688,1.88-.522,2.382-.19c.36.237.474.842.835.631s.743-1.6.743-1.6Z",
    transform: "translate(-713.855 -371.042)",
    fill: "#ffb17d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46332",
    "data-name": "Path 46332",
    d: "M812.659,294.023s5.071.223,6.29,1.354,8.516,9.877,8.637,12.17-6.393,8.806-6.393,8.806a5.026,5.026,0,0,1-2.593-1.575s4.041-7.205,3.8-7.52-7.087-5.923-7.647-4.679c-.484,1.073-2.092-8.555-2.092-8.555",
    transform: "translate(-692.018 -250.375)",
    fill: "#619fdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46333",
    "data-name": "Path 46333",
    d: "M678.849,306.785s5.79,1.931,6.514,1.769,1.757-8.006,2.316-10.695a5.2,5.2,0,0,1,3.464-4.152l2.6-.7s-2.981,7.365-3.069,8.855-.351,24.373-.351,24.373.176,1.053-1.841.613a6.741,6.741,0,0,1-2.542-.877s.874-6.4,1.285-12.075c-2.054-.351-8.66-3.7-8.66-3.7-1.025-1.61.281-3.417.281-3.417",
    transform: "translate(-577.499 -249.513)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46334",
    "data-name": "Path 46334",
    d: "M760.918,222.681c-2.675,1.569-1.833,2.637-2.525,4.061,0,0-.8-2.756.453-4.275,1.331-1.613,2.073.213,2.073.213",
    transform: "translate(-645.592 -188.876)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46335",
    "data-name": "Path 46335",
    d: "M767.553,223.129q.533-.25.738.1a1.71,1.71,0,0,1-.788,1.245,2.194,2.194,0,0,0,.05-1.348",
    transform: "translate(-653.565 -189.917)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46336",
    "data-name": "Path 46336",
    d: "M791.058,209.288q-.7-.2-.609-.7a2.123,2.123,0,0,1,1.749-.53,2.72,2.72,0,0,0-1.14,1.225",
    transform: "translate(-673.096 -177.154)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46337",
    "data-name": "Path 46337",
    d: "M805.04,246.3q-.8-.825-1.421-.319a3.341,3.341,0,0,0,.584,2.819,4.285,4.285,0,0,1,.837-2.5",
    transform: "translate(-684.247 -209.302)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46338",
    "data-name": "Path 46338",
    d: "M760.4,230.287q-.435-1.622-.9-.955a13.886,13.886,0,0,0,.061,4.914,13.6,13.6,0,0,1,.843-3.96",
    transform: "translate(-646.591 -195.122)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46339",
    "data-name": "Path 46339",
    d: "M760.715,224.277c.38-1.054-.72-.989-1.23-.8a13.889,13.889,0,0,0-2.757,4.069c.941-.813,4.086-2.335,3.987-3.266",
    transform: "translate(-644.39 -190.206)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46340",
    "data-name": "Path 46340",
    d: "M791.459,208.57a.729.729,0,0,0,.237-.7q-.315-.677-.681-.53a3.06,3.06,0,0,1,.443,1.225",
    transform: "translate(-673.588 -176.541)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46354",
    "data-name": "Path 46354",
    d: "M774.869,217.316s1.056,4.141,3.924,5.466c0,0-2.868-2.544-3.112-5.277s-.812-.189-.812-.189",
    transform: "translate(-659.838 -184.138)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46355",
    "data-name": "Path 46355",
    d: "M776.619,216.554s1.482,3.954,3.754,4.538,3.261-.024,3.261-.024a6.44,6.44,0,0,1-2.1-3.8s-3.793-2.594-4.91-.711",
    transform: "translate(-661.328 -183.823)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46356",
    "data-name": "Path 46356",
    d: "M781.348,220.723a7.473,7.473,0,0,1-1.855-.26c-2.313-.6-3.784-4.456-3.846-4.62l-.022-.06.033-.054a1.462,1.462,0,0,1,.981-.7c1.572-.342,4.016,1.3,4.119,1.372l.048.033.009.058a6.344,6.344,0,0,0,2.055,3.718l.149.118-.162.1a3.023,3.023,0,0,1-1.509.3m-5.427-4.914c.2.5,1.612,3.874,3.639,4.4a5.1,5.1,0,0,0,2.981.069,6.561,6.561,0,0,1-1.982-3.688c-.348-.227-2.511-1.6-3.863-1.3a1.191,1.191,0,0,0-.775.522",
    transform: "translate(-660.481 -183.064)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1819",
    "data-name": "Rectangle 1819",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 573.199, 250.678)",
    fill: "none",
    stroke: "#16d696",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.771,
    height: 7.771,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.771,
    height: 6.771,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1818",
    "data-name": "Rectangle 1818",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 911.39, 323.754)",
    fill: "none",
    stroke: "#040227",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.192,
    height: 9.192,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8.192,
    height: 8.192,
    rx: 1.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardPencil);
export default __webpack_public_path__ + "static/media/icon-clipboard-pencil.383fc4c0757ebe7dbc0cc736198e9eae.svg";
export { ForwardRef as ReactComponent };